const ROW_LABEL = {
  member: "每位學生",
  school_cls: "每班",
  grp: "每社",
  organization: "每校",
};

function cleanSegment(value) {
  const text = String(value ?? "").trim();
  if (text === "" || text.includes("/") || text.includes("?")) {
    return "";
  }
  return text;
}

function scopeHeadline(scope, scopeArg) {
  if (scope === "organization") {
    return "本校";
  }
  if (scope === "form") {
    return scopeArg ? `${scopeArg} 年級` : "未選擇級別";
  }
  if (scope === "grp") {
    return scopeArg || "未選擇社";
  }
  return "";
}

function metricLine(item, skillCode, skillName) {
  if (item === "duration") {
    return "全部活動累計時長";
  }
  if (item === "score") {
    const name = skillName || (skillCode && skillCode !== "all" ? skillCode : "");
    return `最佳成績：${name || "未選擇活動"}`;
  }
  return "";
}

function scopeArgFor(scope, scopeArg) {
  if (scope === "organization") {
    return "_";
  }
  return cleanSegment(scopeArg);
}

function skillFor(item, skillCode) {
  if (item === "duration") {
    return "all";
  }
  const code = cleanSegment(skillCode);
  if (code === "" || code.toLowerCase() === "all") {
    return "";
  }
  return code;
}

// scope/scopeArg/groupBy/item/skillCode. Organization always uses "_".
export function buildLeaderboard(selection) {
  const scope = cleanSegment(selection?.scope);
  const groupBy = cleanSegment(selection?.groupBy);
  const item = cleanSegment(selection?.item);
  const title = cleanSegment(selection?.title);
  const scopeArg = scopeArgFor(scope, selection?.scopeArg);
  const skillCode = skillFor(item, selection?.skillCode);
  const skillName = String(selection?.skillName ?? "").trim();
  const leaderboardCode = selection?.leaderboardCode;
  const suffix = selection?.suffix;

  let code = [
    scope || "?",
    scopeArg || "?",
    groupBy || "?",
    item || "?",
    skillCode || "?",
  ].join("/");

  if (suffix !== undefined && suffix !== null && suffix !== "") {
    code = code + "/" + suffix;
  }

  console.log("DEBUG: code", code);
  console.log("DEBUG: leaderboardCode", leaderboardCode);

  const headline = [scopeHeadline(scope, scopeArg), ROW_LABEL[groupBy] || ""]
    .filter(Boolean)
    .join(" · ");
  const metric = metricLine(item, skillCode, skillName);
  
  const gradeOk = scope === "grade" && /^[1-7]$/.test(scopeArg);
  const groupOk = scope === "grp" && scopeArg !== "" && scopeArg !== "_";
  const scopeOk = scope === "organization" || gradeOk || groupOk;
  const groupByOk = groupBy === "member" || groupBy === "school_cls" || groupBy === "grp";
  const itemOk = item === "duration" || (item === "score" && skillCode !== "");
  const isTitleOk = title !== "" && title !== null && title !== undefined;
  
  const ready = scopeOk && groupByOk && itemOk && isTitleOk ;

  return { code, title, headline, metricLine: metric, ready };
}
